/**  !!!!!! copy from npm package - node_modules/@bbob/react/es/.
 * Remove defaultProps error.*/

export { default } from './Component';
export { render } from './render';
